<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_v"></a></p>
<p class="noindent"><a id="cont"></a></p>
<h2 class="h2"><strong><em>Contents</em></strong></h2>
<p class="toc-front"><a class="nounder" href="#/xhtml/intro#int">Introduction by Donna Leon</a></p>
<p class="toc-front"><a class="nounder" href="#/xhtml/prac#pra">Practical Guideline</a></p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/ch01#ch1">WALK 1 : Meeting Brunetti</a></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch02#ch2" title="Link target outside of Sample">WALK 2 : Rialto and the Senses</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch03#ch3" title="Link target outside of Sample">WALK 3 : Brunetti’s Neighbourhood</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch04#ch4" title="Link target outside of Sample">WALK 4 : Food and Faliers</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch05#ch5" title="Link target outside of Sample">WALK 5: Weather and Houses</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch06#ch6" title="Link target outside of Sample">WALK 6: Expatriate Venice</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch07#ch7" title="Link target outside of Sample">WALK 7: Rich and Poor</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch08#ch8" title="Link target outside of Sample">WALK 8: Piazza San Marco</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch09#ch9" title="Link target outside of Sample">WALK 9: Questura World</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">WALK 10: Remote Venice</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">WALK 11: Artful Properties</span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">WALK 12: The Most Beautiful Neighbourhood in the World</span></p>
<p class="toc-back"><span class="nounder" href="#/xhtml/back01#back" title="Link target outside of Sample">Brunetti’s Lagoon Islands</span></p>
<p class="bgh"><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?466a48fe